import { useNavigate } from "react-router-dom";
import { APPS_CATALOG } from "@/data/appsCatalog";

export default function ApplicationsPage() {
  const navigate = useNavigate();
  return (
    <div className="page-shell space-y-5">
      <div className="app-page-header">
        <h1 className="app-page-title">Uygulamalar</h1>
        <p className="app-page-subtitle">Muhasebe ve e-fatura uygulamalarını ObiHub’a bağlayın.</p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        {APPS_CATALOG.map((app) => (
          <article key={app.slug} className="rounded-2xl border border-border bg-card p-4 shadow-sm">
            <div className="flex items-center justify-between gap-3">
              <div className="flex min-w-0 items-center gap-3">
                {app.logo ? (
                  <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-border bg-white p-1.5 shadow-sm">
                    <img src={app.logo} alt={`${app.name} logosu`} className="h-full w-full object-contain" />
                  </span>
                ) : null}
                <h2 className="truncate text-base font-semibold text-foreground">{app.name}</h2>
              </div>
              <span
                className={`inline-flex rounded-full px-2 py-0.5 text-[10px] font-semibold ${
                  app.status === "active"
                    ? "bg-emerald-100 text-emerald-700"
                    : "bg-muted/60 text-muted-foreground"
                }`}
              >
                {app.status === "active" ? "Aktif" : "Yakında"}
              </span>
            </div>
            <div className="mt-1 text-xs text-muted-foreground">{app.category}</div>
            <p className="mt-3 min-h-[48px] text-sm text-muted-foreground">{app.description}</p>
            <div className="mt-4">
              <button
                type="button"
                onClick={() => navigate(`/panel/uygulamalar/${app.slug}`)}
                className={`h-9 w-full rounded-xl px-3 text-xs font-semibold ${
                  app.status === "active"
                    ? "bg-[#1487a3] text-white hover:bg-[#1f79ad]"
                    : "border border-border bg-muted/50 text-muted-foreground"
                }`}
              >
                Detayı İncele
              </button>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
